/* globals console, module, require */
/* jshint esversion: 6 */
/* jshint globalstrict: true */
'use strict';

const Marionette = require('backbone.marionette'),
    jQuery = require('jquery'),
    _ = require('lodash'),
    //
    templates = require('../utilities/handlebars').templates,
    EOL = null;

module.exports = Marionette.View.extend({
    attributes: {
        class: 'filterSetsListItem'
    },
    tagName: 'option',
    template: templates.filterSetsListItem,
    //
    initialize: function () {
        jQuery(this.$el).val(this.model.id);
    }
});
